import { Divider } from "antd";
import parse from "html-react-parser";
import moment from "moment";
import React from "react";

import campaign from "../../../assets/images/NewIcons/campaign_selected.svg";
import journey from "../../../assets/images/NewIcons/journey_selected.svg";
import account from "../../../assets/images/notifications/account.png";
import billing from "../../../assets/images/notifications/billing.png";
import wallet from "../../../assets/images/notifications/wallet.png";

const account_types = ["acc_notification", "suspension_overusage"];
const billing_types = [
	"payment_succeeded",
	"cancel_subscription",
	"payment_failed",
];
const wallet_types = [
	"topup_succeeded",
	"updatep_plan_fail",
	"auto_topup_succeeded",
	"auto_topup_failed",
	"fact_balance",
	"low_fact_balance",
	"daily_transaction_summary",
	"manual_top_up_alert_notification",
];
const campaign_types = ["campaign_aborted", "journey_aborted", "campaign"];

const journey_types = ["journey"];

const NotificationIndex = ({ item, index }) => {
	return (
		<div className="notification-content" key={index}>
			<div className="notification-info">
				<div className="notification-info-left">{index + 1}</div>
				<div className="notification-info-right">
					<div className="notification-info-top-row">
						<div className="notification-info-title">
							<NotificationIcon
								item={item}
								campaign_types={campaign_types}
								wallet_types={wallet_types}
								billing_types={billing_types}
								account_types={account_types}
								journey_types={journey_types}
							/>
							<p>
								<b style={{ fontWeight: 800, fontSize: "14px" }}>{item.name}</b>
							</p>
						</div>
						<p>{moment(item.date).format("DD MMM")}</p>
					</div>
					<div className="notification-info-bottom-row" id="html-text">
						{item.text.includes("<p>") ? parse(item.text) : item.text}
					</div>
				</div>
			</div>
			<Divider />
		</div>
	);
};

export default NotificationIndex;

const NotificationIcon = ({
	item,
	campaign_types,
	wallet_types,
	billing_types,
	account_types,
	journey_types,
}) => {
	let iconSrc = "";
	switch (true) {
		case campaign_types.includes(item.type):
			iconSrc = campaign;
			break;
		case wallet_types.includes(item.type):
			iconSrc = wallet;
			break;
		case billing_types.includes(item.type):
			iconSrc = billing;
			break;
		case account_types.includes(item.type):
			iconSrc = account;
			break;
		case journey_types.includes(item.type):
			iconSrc = journey;
			break;
		default:
			iconSrc = account;
	}

	return (
		<img src={iconSrc} className="notification-icon" alt="Notification Icon" />
	);
};
